module.exports = __webpack_public_path__ + "static/media/orange01.5cefca7c.svg";